var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSlice1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 40,
    viewBox: "0 0 24 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#n9gwdzg69a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.912 28.146h-5.915a5.985 5.985 0 0 1-1.756 4.234 6.002 6.002 0 0 1-8.482 0 5.984 5.984 0 0 1-1.756-4.234H.005c0 3.176 1.264 6.223 3.513 8.47a12.003 12.003 0 0 0 16.964 0 11.969 11.969 0 0 0 3.513-8.47h-.087",
    fill: "url(#503d6z58nb)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.998 0v5.989c1.59 0 3.116.63 4.241 1.754a5.985 5.985 0 0 1 1.757 4.235v.31a5.986 5.986 0 0 1-1.833 4.009 6.002 6.002 0 0 1-4.084 1.671h-.155a6.002 6.002 0 0 1-4.082-1.672 5.985 5.985 0 0 1-1.832-4.008H.012a11.97 11.97 0 0 0 3.592 8.247 12.004 12.004 0 0 0 8.327 3.426h.155a12.004 12.004 0 0 0 8.328-3.426 11.97 11.97 0 0 0 3.593-8.247v-.31a11.962 11.962 0 0 0-3.518-8.475A11.996 11.996 0 0 0 11.999 0z",
    fill: "url(#2dfd6rtb8c)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.998 0v5.989c1.59 0 3.116.63 4.241 1.754a5.985 5.985 0 0 1 1.757 4.235v.31a5.985 5.985 0 0 1-1.833 4.009 6.002 6.002 0 0 1-4.084 1.671h-.155a11.95 11.95 0 0 0-7.86 2.995 11.959 11.959 0 0 0 7.86 2.994h.155a12.003 12.003 0 0 0 8.328-3.425A11.97 11.97 0 0 0 24 12.284v-.31a11.964 11.964 0 0 0-3.517-8.47A11.996 11.996 0 0 0 11.998 0z",
    fill: "url(#b3yoc1s1bd)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.048.086v5.637h5.644V.086H.048z",
    fill: "#22C4AC"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "503d6z58nb",
    x1: 9.779,
    y1: 25.703,
    x2: -1.941,
    y2: 4.791,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#596AE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#22C4AC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "2dfd6rtb8c",
    x1: 17.849,
    y1: 18.65,
    x2: 2.059,
    y2: 0.603,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#596AE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#22C4AC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b3yoc1s1bd",
    x1: 13.702,
    y1: 18.78,
    x2: 17.389,
    y2: -0.788,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#596AE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#22C4AC"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "n9gwdzg69a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v40H0z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSlice1);
export default __webpack_public_path__ + "static/media/Slice1.68f697e8434b8cfbbdb67c6001ea39bc.svg";
export { ForwardRef as ReactComponent };